import info from '../Info';
import validation from '../Validation';

import inputTemplate from './input.ejs';
import styles from './styles.less';

interface Data {
    label: string;
    name: string;
    readOnly?: boolean;
    required?: boolean;
    type: string;
    value?: string;
    pattern?: string;

    attrs?: Record<string, any>;
}

export default function({ attrs = {}, ...data }: Data) {
    return inputTemplate({
        ...data,
        attrs,
        info,
        validation,
        styles,
    });
}
